// Generated types for Material
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { CatalogNodeReadAPI, CatalogNodeWriteAPI } from '../../shared/types/catalognode';
import { CatalogNodeReadAPISchemaObject, CatalogNodeWriteAPISchemaObject } from '../../shared/types/catalognode';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface MaterialReadAPI extends CatalogNodeReadAPI {
}

export interface MaterialWriteAPI extends CatalogNodeWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const MaterialReadAPISchema: z.ZodType<MaterialReadAPI> = CatalogNodeReadAPISchemaObject.extend({}).passthrough();

export const MaterialWriteAPISchema: z.ZodType<MaterialWriteAPI> = CatalogNodeWriteAPISchemaObject.extend({}).passthrough();
